import React, { useState } from "react";
import {  Link } from "react-router-dom";
import { DocumentViewer } from 'react-documents';


const PageDetails = ({ selectedPage, onUpdate }) => {
  const authToken = localStorage.getItem("token");

    const [pageData, setPageData] = useState(selectedPage);
    


  return (
     <>    
   
    <div className="col-md-8">
       <h1>{pageData.title || ""}</h1>
       <div dangerouslySetInnerHTML={{ __html: pageData.description }} />
       {pageData.media_type==='Image' && pageData.uploaded_file_url && (
                    <div className="text-center">                       
                        <img src={pageData.uploaded_file_url} alt="Cover Preview"  className="img-fluid" />                        
                    </div>
                )}     
{pageData.media_type==='Audio' && pageData.uploaded_file_url && (
                    <div className="text-center mt-2">   
                    <audio width="auto" style={{maxWidth:"100%"}} height="360" controls controlsList="nodownload">
                    <source src={pageData.uploaded_file_url} type="audio/mpeg" /> 
                    </audio>
                                              
                    </div>
                )}          
{pageData.media_type==='Video' && pageData.uploaded_file_url && (
                    <div className="text-center mt-2">   
                    <video width="auto" style={{maxWidth:"100%"}} height="360" controls controlsList="nodownload">
                    <source src={pageData.uploaded_file_url} type="video/mp4" /> 
                    </video>
                                              
                    </div>
                )}    
   {pageData.media_type==='Presentation/Document' && pageData.uploaded_file_url && (
                    <div className="text-center mt-2"> 
                      <DocumentViewer
    queryParams="hl=en"
    url={pageData.uploaded_file_url}
  
    viewer="google"
    googleCheckContentLoaded ={ true}
    style={{width:"100%",height:"80vh"}}

    ></DocumentViewer>
  
                  {/*  <iframe
    src={`https://drive.google.com/viewerng/viewer?url=${(pageData.uploaded_file_url)}&embedded=true`}
    width="100%"
    height="600px"
 
   
></iframe>           */}  
                    </div>
                )}    

                {pageData.media_type==='Iframe' && pageData.iframe && (
                  <div className="text-center mt-2">{pageData.iframe}</div>
                )}
    </div>
    </>   
  );
};

export default PageDetails;
